<template>
    <div class="switch-wrapper" :class="wrapperClass">
        <label v-if="label" class="switch-wrapper__label">{{ label }}</label>
        <label class="switch">
            <input
                :id="inputId"
                type="checkbox"
                :checked="isChecked"
                :disabled="disabled"
                @change="onChange"
            >
            <span class="slider" :class="{ round }"></span>
        </label>
        <input
            v-if="name && !disabled"
            type="hidden"
            :name="name"
            :value="isChecked ? 1 : 0"
        >
    </div>
</template>

<script>
/**
 * Vue port of partials/inputs/buttons/_slider-button.blade.php
 * Styles: resources/sass/admin-panel/partials/buttons/_slider-button.scss
 */
export default {
    props: {
        modelValue: {
            type: [Boolean, Number, String],
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        inputId: {
            type: String,
            required: true,
        },
        round: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        labelAlign: {
            type: String,
            default: 'horizontal',
            validator: (value) => ['horizontal', 'vertical'].includes(value),
        },
    },
    emits: ['update:modelValue'],
    computed: {
        wrapperClass() {
            return {
                'switch-wrapper--vertical': this.labelAlign === 'vertical',
            };
        },
        isChecked() {
            return this.modelValue === true
                || this.modelValue === 1
                || this.modelValue === '1';
        },
    },
    methods: {
        onChange(event) {
            if (this.disabled) {
                return;
            }

            this.$emit('update:modelValue', event.target.checked);
        },
    },
};
</script>

<style scoped>
.switch-wrapper--vertical {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.switch-wrapper--vertical .switch-wrapper__label {
    margin-bottom: 0;
}

.switch-wrapper .switch input:disabled + .slider {
    cursor: not-allowed;
    opacity: 0.65;
}
</style>
